module.exports = __webpack_public_path__ + "media/src/images/favicons/mstile-70x70-303ef1a6804f2bc32361c270f601e848.png";